import React from 'react'
import styles from './SeoHomepage.scss'

const SeoHomepage = () => (
  <div className={`container ${styles['homepage-seo-footer']}`}>
    <small data-test='homepage-seo-text'>
      <p>
        With the autumn leaves falling from the trees, the weather cools and the evenings grow shorter. This year's warm
        summer evenings are behind us and now the living room becomes the center of social and relaxation time. How's
        yours looking? Many take this opportunity to make improvements, be it a large-scale redecoration, or simply
        introducing some new{' '}
        <a href='//www.argos.co.uk/browse/home-and-furniture/living-room-furniture/c:29368/'>living room furniture</a>{' '}
        to make better use of the space. Corner sofas, naturally, take advantage of corners and are spacious enough to
        properly spread out on.{' '}
        <a href='//www.argos.co.uk/browse/home-and-furniture/living-room-furniture/sofa-beds/c:29644/'>Sofa beds</a>, on
        the other hand, take space-saving to another level by eliminating the need for a guest bedroom. Many are compact
        enough to put in other bedrooms or studies too, how's that for versatility?
      </p>
      <p>
        Whether you're escaping to continue enjoying the warm weather elsewhere, going on a business trip to another
        city, or just out on an adventure, you'll need something to carry your possessions in.{' '}
        <a href='//www.argos.co.uk/browse/sports-and-leisure/bags-luggage-and-travel/suitcases/c:30493/'>Suitcases</a>{' '}
        come in different forms, from lightweight cases to meet weight restrictions, to hard shell cases for maximum
        protection against cavalier treatment at the airport. For those still at home during holiday periods, don't
        fret. We have activity lined up for <a href='//www.argos.co.uk/events/calendar-events'>calendar events</a> like
        Halloween and Black Friday, so there'll be plenty of ways to enjoy your time at home.
      </p>
      <p>
        The world of computing is always evolving and, before you know it, your trusty old laptop with 2GB RAM can no
        longer keep up. The <a href='//www.argos.co.uk/browse/technology/laptops-and-pcs/c:29953/'>laptop</a> market has
        a huge range of brands and specs to choose from, from lightweight and portable options, like the Microsoft
        Surface, through to gaming laptops with powerful graphics cards and processors. Speaking of gaming, there are
        many upcoming games to be excited about, so there's no better time to upgrade or try your first console. That's
        whether you're native to the versatile{' '}
        <a href='//www.argos.co.uk/browse/technology/video-games-and-consoles/nintendo-switch/c:30291/'>
          Nintendo Switch
        </a>
        , the powerful{' '}
        <a href='//www.argos.co.uk/browse/technology/video-games-and-consoles/xbox-one/c:29994/'>Xbox One</a>, or the
        mighty <a href='//www.argos.co.uk/browse/technology/video-games-and-consoles/ps4/c:29995/'>PS4</a>. The great
        outdoors also provides entertainment, so don't forget to give it a go, whether that's a game of football in the
        park or an autumn walk with the kids. Make it more interesting for them with an{' '}
        <a href='//www.argos.co.uk/browse/toys/outdoor-toys/wheeled-toys/scooters/c:30334/type:electric/'>
          electric scooter
        </a>{' '}
        - not only are they great fun and a form of exercise, they are also a very eco-friendly method of transport!
      </p>
    </small>
  </div>
)

export default SeoHomepage
